import React, {useContext, useEffect, useState} from "react";
import {
    Button,
    Card,
    Form,
    FormLayout, ChoiceList,
    Layout,
    Page,
    Select,
    SkeletonBodyText,
    SkeletonDisplayText,
    TextField, List, Banner
} from "@shopify/polaris";
import _ from 'lodash';
import axios from "../../axios";
import {ShopContext} from "../../App";
import {useHistory, useParams} from "react-router-dom";
import Notice from "../../components/Notice";
import WhatsappChatWindow from "../../components/WhatsappChatWindow";
import Switch from "react-switch";
import Br from "../../components/Br";
import PhoneInput from "react-phone-input-2";

const CreateOrEdit = () => {
    const router = useHistory();
    const config = useContext(ShopContext);
    let {id, task, type} = useParams();
    if (!['pre_order', 'post_order_payment', 'post_order_delivery'].includes(type)) {
        type = 'pre_order';
    }
    const [automationId, setAutomationId] = useState(parseInt(id));

    let notificationTypeTitle = "Automation";
    config.tabIndex = "0";
    if (type === "post_order_payment") {
        config.tabIndex = "1";
        notificationTypeTitle = "Order confirmation";
    } else if (type === "post_order_delivery") {
        config.tabIndex = "2";
        notificationTypeTitle = "Order delivery";
    }

    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingTemplates, setLoadingTemplates] = useState(false);
    const [showNotice, setShowNotice] = useState(false);
    const [noticeMessage, setNoticeMessage] = useState("");
    const [noticeType, setNoticeType] = useState("info");

    const [couponCode, setCouponCode] = useState('');
    const [couponCodeValue, setCouponCodeValue] = useState('5');
    const [couponCodeExpiryDays, setCouponCodeExpiryDays] = useState('0');
    const [delay, setDelay] = useState('1');
    const [delayType, setDelayType] = useState('hours');
    const [languageCode, setLanguageCode] = useState('en_US');
    const [templateId, setTemplateId] = useState('en_US_1');
    const [templates, setTemplates] = useState([]);
    const [couponCodeType, setCouponCodeType] = useState('none');
    const [rawTemplates, setRawTemplates] = useState([]);
    const [currentTemplate, setCurrentTemplate] = useState({});
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState(0);
    const [whatsappNumber, setWhatsappNumber] = useState('');
    const [languages, setLanguages] = useState([]);


    const processTemplate = (templates) => {
        let processedTemplates = [{label: 'Select template', value: 'select_template'}];
        templates.forEach((template) => {
            let templateType = _.get(template, 'type', 'pre_order');
            if (type === templateType) {
                processedTemplates.push({
                    label: `${template.message.substring(0, 100)}${template.message.length > 100 ? '...' : ''}`,
                    value: template.id
                });
            }
        });
        return processedTemplates;
    }
    useEffect(() => {
        setLoadingTemplates(true);
        setRawTemplates([]);
        setTemplates([]);
        if (languageCode) {
            axios.get(`/automations/templates/${languageCode}`, {
                "headers": {
                    shopOrigin: config.shopOrigin,
                    xShopHost: config.host,
                }
            }).then((response) => {
                setRawTemplates(_.get(response, 'data.templates', []));
                setTemplates(processTemplate(_.get(response, 'data.templates', [])));
                let tempTemplateId = templateId.replace(/^.{5}/g, languageCode);
                setTemplateId(tempTemplateId);
                let messageTemplate = getTemplateContent(tempTemplateId, _.get(response, 'data.templates', []));
                setMessage(messageTemplate);

                // setTemplateId('select_template');
                // setMessage('');
                // setCurrentTemplate({});

                setLoadingTemplates(false);
            }).catch((e) => {
                setLoadingTemplates(false);
            });
        }
    }, [config, languageCode])
    useEffect(() => {
        setLoading(true);
        axios.get(`/automations/${automationId}`, {
            "headers": {
                shopOrigin: config.shopOrigin,
                xShopHost: config.host,
            }
        }).then((response) => {
            let success = _.get(response, 'success', false)
            if (success) {
                let data = _.get(response, 'data', {});
                setCouponCode(_.get(data, 'coupon_code', ''));
                setCouponCodeType(_.get(data, 'coupon_code_type', 'none'));
                setWhatsappNumber(_.get(data, 'whatsapp_number', ''));
                setDelayType(_.get(data, 'delay_type', 'hours'));
                setDelay(_.get(data, 'delay_unit', '1'));
                setCouponCodeValue(_.get(data, 'coupon_value', '5'));
                setCouponCodeExpiryDays(_.get(data, 'coupon_expiry_days', '0'));
                setStatus(_.get(data, 'status', 0));
                setRawTemplates(_.get(data, 'templates', []));
                setTemplates(processTemplate(_.get(data, 'templates', [])));
                setLanguages(_.get(data, 'languages', []));
                setTimeout(() => {
                    setTemplateId(_.get(data, 'message_id', 'en_US_1'));
                    setLanguageCode(_.get(data, 'language_code', 'en_US'));
                    let messageTemplate = getTemplateContent(_.get(data, 'message_id', 'en_US_1'), _.get(data, 'templates', []));
                    setMessage(messageTemplate);
                    setLoading(false);
                }, 1000)
                // parseMessage();
            }
        }).catch((error) => {
            setLoading(false)
        })
    }, [automationId, config])

    const getTemplateContent = (templateId, templates) => {
        let currentTemplate = templates.find((template) => template.id === templateId);
        if (currentTemplate) {
            setCurrentTemplate(currentTemplate);
            return currentTemplate.message;
        } else {
            setCurrentTemplate({});
        }
        return '';
    }
    const saveAutomation = (close = false) => {
        if (templateId === 'select_template') {
            setShowNotice(true);
            setNoticeMessage('Please select the template.');
            setNoticeType('warning');
            return false;
        }
        if (+delay > 0) {
            let modifiedAutomation = {
                id: automationId,
                template_id: templateId,
                language_code: languageCode,
                status: status,
                delay_unit: delay,
                whatsapp_number: whatsappNumber,
                coupon_code: couponCode,
                coupon_value: couponCodeValue,
                coupon_expiry_days: couponCodeExpiryDays,
                delay_type: delayType,
                notification_type: type,
                coupon_type: couponCodeType,
            }
            setSaving(true);
            axios.post(`/automations/${automationId}`, modifiedAutomation, {
                "headers": {
                    shopOrigin: config.shopOrigin,
                    xShopHost: config.host,
                }
            }).then((response) => {
                setShowNotice(true);
                setNoticeMessage(_.get(response, 'message', ''));
                let error = false;
                if (_.get(response, 'success', false)) {
                    setAutomationId(response.data.id);
                    setNoticeType('success');
                } else {
                    setNoticeType('critical');
                    error = true;
                }
                setSaving(false);
                if (close && !error) {
                    router.push('/automations');
                }
            }).catch((error) => {
                setSaving(false);
                setShowNotice(true);
                setNoticeMessage("Error in saving automation!");
                setNoticeType('critical');
            });
        } else {
            setShowNotice(true);
            setNoticeMessage('Delay should grater than zero');
            setNoticeType('warning');
        }
    }

    return <Page
        breadcrumbs={[{
            accessibilityLabel: 'Automations',
            disabled: saving,
            content: 'Automations', onAction: () => {
                router.push('/automations');
            }
        }]}
        primaryAction={{
            content: 'Save and close',
            onAction: () => {
                saveAutomation(true);
            },
            disabled: saving,
            loading: saving
        }}
        secondaryActions={[{
            content: 'Cancel',
            disabled: saving,
            onAction: () => {
                router.push('/automations');
            }
        }]}
        fullWidth={true}
        title={(task === "edit") ? `Edit ${notificationTypeTitle.toLowerCase()}` : `Create ${notificationTypeTitle.toLowerCase()}`}
        separator
    >
        <Notice message={noticeMessage} show={showNotice} onClose={() => {
            setShowNotice(false);
        }} status={noticeType}/>
        <Layout>
            <Layout.Section>
                {loading && <Card>
                    <Card.Section>
                        <SkeletonDisplayText size="small"/>
                        <div>&nbsp;</div>
                        <SkeletonBodyText lines={3}/>
                        <div>&nbsp;</div>
                        <SkeletonDisplayText size="small"/>
                        <div>&nbsp;</div>
                        <SkeletonBodyText lines={3}/>
                        <div>&nbsp;</div>
                        <SkeletonDisplayText size="small"/>
                        <div>&nbsp;</div>
                        <SkeletonBodyText lines={3}/>
                    </Card.Section>
                </Card>}
                {!loading && <div>
                    <Card title={`${notificationTypeTitle} template`} sectioned>
                        <FormLayout>
                            <Form onSubmit={() => {
                                saveAutomation(false)
                            }}>
                                {type === 'pre_order' && <>
                                    <div>
                                        <div className="Polaris-Card">
                                            <div className="Polaris-Card__Section">
                                                <div className="Polaris-SettingAction">
                                                    <div className="Polaris-SettingAction__Setting">Enable the
                                                        automation?
                                                    </div>
                                                    <div className="Polaris-SettingAction__Action">
                                                        <Switch onChange={(value) => {
                                                            setStatus((value) ? 1 : 0);
                                                        }} checked={status === 1}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Br height={10}/>
                                    <TextField
                                        label={<p>Wait for<span className="important">*</span></p>}
                                        type="number"
                                        helpText='Minimum should be 1 hour.'
                                        value={delay.toString()}
                                        onChange={(delay) => {
                                            setDelay(delay);
                                        }}
                                        connectedRight={
                                            <Select
                                                value={delayType}
                                                label={<p>Delay type<span className="important">*</span></p>}
                                                onChange={setDelayType}
                                                labelHidden
                                                options={['hours', 'days']}
                                            />
                                        }
                                    /></>}
                                <Br height={10}/>
                                <Select
                                    value={languageCode}
                                    label={<p>Template language<span className="important">*</span></p>}
                                    onChange={(language) => {
                                        setLanguageCode(language);
                                        setCurrentTemplate({});
                                    }}
                                    options={languages}
                                />
                                <Br height={10}/>
                                {templates.length > 0 &&
                                <div>
                                    {type === "pre_order" ? <Select
                                        label={<p>Message template<span className="important">*</span></p>}
                                        options={templates}
                                        onChange={(value) => {
                                            let messageTemplate = getTemplateContent(value, rawTemplates);
                                            setMessage(messageTemplate);
                                            setTemplateId(value);
                                        }}
                                        value={templateId}
                                    /> : <>
                                        <TextField
                                            label={<p>Message template<span className="important">*</span></p>}
                                            value={message}
                                            onChange={() => {
                                            }}
                                            multiline={4}
                                        />
                                    </>}
                                    <Br height={20}/>
                                </div>
                                }
                                {loadingTemplates && <div><p>Loading templates...</p><Br height={20}/></div>}
                                {_.get(currentTemplate, 'hasWhatsappShortcode', false) &&
                                <div className="">
                                    <div className="">
                                        <div className="Polaris-Labelled__LabelWrapper">
                                            <div className="Polaris-Label">
                                                <label className="Polaris-Label__Text">WhatsApp Phone number <span
                                                    className="important">*</span></label></div>
                                        </div>
                                        <PhoneInput
                                            autoFormat={false}
                                            countryCodeEditable={false}
                                            enableSearch={true}
                                            containerStyle={{zIndex: "999"}}
                                            inputStyle={{width: "100%", borderColor: "#c4cdd5"}}
                                            country={'us'}
                                            value={whatsappNumber}
                                            onChange={(value) => {
                                                setWhatsappNumber(value);
                                                // parseMessage();
                                            }}
                                        />
                                    </div>
                                    <div className="Polaris-Labelled__HelpText">
                                        <p>This number will be sent in the message replacing
                                            the &#123;&#123;phone_number&#125;&#125;  liquid tag and also used to
                                            construct the WhatsApp Link to
                                            replace &#123;&#123;whatsapp_link&#125;&#125;</p>
                                    </div>
                                    <Br height={20}/>
                                </div>
                                }
                                {_.get(currentTemplate, 'hasCouponCode', false) &&
                                <>
                                    <ChoiceList
                                        title={<p>Coupon code type<span className="important">*</span></p>}
                                        choices={[
                                            {label: 'No coupon code', value: 'none'},
                                            {label: 'Static coupon code', value: 'static'},
                                            {label: 'Dynamic coupon code', value: 'dynamic'},
                                        ]}
                                        selected={couponCodeType}
                                        onChange={(value) => {
                                            setCouponCodeType(value[0]);
                                        }}
                                    />
                                    <Br height={20}/>
                                    {couponCodeType !== 'none' && <>
                                        <div className="no-margin-form-field">
                                            {couponCodeType === 'dynamic' && <>
                                                <FormLayout.Group>
                                                    <TextField
                                                        type="number" value={String(couponCodeValue)}
                                                        label={<p>Coupon value (percentage)<span
                                                            className="important">*</span></p>}
                                                        suffix="%"
                                                        onChange={(value) => {
                                                            if (value === '' || parseInt(value) <= 100) {
                                                                setCouponCodeValue(value);
                                                            }
                                                        }}/>
                                                    <TextField
                                                        type="number" value={String(couponCodeExpiryDays)}
                                                        label="Coupon expiry (days)" suffix="Days"
                                                        onChange={(value) => {
                                                            if (value === '' || parseInt(value) <= 100) {
                                                                setCouponCodeExpiryDays(value);
                                                            }
                                                        }}/>
                                                </FormLayout.Group>
                                                <Br height={10}/>
                                            </>
                                            }
                                        </div>
                                        <TextField
                                            label={<p>Coupon message<span className="important">*</span></p>}
                                            value={couponCode}
                                            onChange={(couponCode) => {
                                                if (couponCode.length <= 200) {
                                                    setCouponCode(couponCode);
                                                }
                                            }}
                                            placeholder={(couponCodeType === 'static')? "Use coupon code SPECIAL5 to get 5% off": "Use {{dynamic_coupon_code}} to get 10% discount on your next order. Valid for 5 days. Hurry!"}
                                            helpText={<div>
                                                {couponCodeType === 'dynamic' && <Banner status="info">
                                                    <div>In the coupon message field, you can use the following liquid
                                                        short code:
                                                    </div>
                                                    <ul>
                                                        <li>&#123;&#123;dynamic_coupon_code&#125;&#125; Before sending
                                                            the message, this will be replaced with the dynamically
                                                            generated coupon code.
                                                        </li>
                                                    </ul>
                                                    <p>
                                                        <b>Example:</b> Use &#123;&#123;dynamic_coupon_code&#125;&#125; to
                                                        get 10% discount on your next order. Valid for 5 days. Hurry!
                                                    </p>
                                                </Banner>}
                                                {couponCodeType === 'static' &&
                                                <p>You can include a message with a coupon code in this field.
                                                    <b>Example:</b> Use coupon code SPECIAL5 to get 5% off. NOTE: You
                                                    should
                                                    have
                                                    created this coupon code in your <b>Shopify dashboard ->
                                                        discounts</b>
                                                </p>}
                                            </div>}
                                        />
                                        <Br height={10}/>
                                    </>}
                                </>
                                }
                                <Button submit primary loading={saving}>Save</Button>
                            </Form>
                        </FormLayout>
                    </Card>
                </div>}
            </Layout.Section>
            <Layout.Section secondary>
                <Card title="Preview" sectioned>
                    <WhatsappChatWindow message={message}/>
                </Card>
            </Layout.Section>
        </Layout>
    </Page>
}

export default CreateOrEdit;
